import type { HashtagListResponsePageAllOfThreeContentItemAuth } from './hashtagListResponsePageAllOfThreeContentItemAuth';
import type { HashtagListResponsePageAllOfThreeContentItemBasicInfo } from './hashtagListResponsePageAllOfThreeContentItemBasicInfo';
import type { HashtagListResponsePageAllOfThreeContentItemStats } from './hashtagListResponsePageAllOfThreeContentItemStats';

export type HashtagListResponsePageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  auth?: HashtagListResponsePageAllOfThreeContentItemAuth;
  /** 해시태그 기본 정보 */
  basicInfo?: HashtagListResponsePageAllOfThreeContentItemBasicInfo;
  /** 해시태그 통계 정보 */
  stats?: HashtagListResponsePageAllOfThreeContentItemStats;
};
